// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"c219a217362db9a6aa31","3":"a99f912176010431e84d","4":"c96ef6ba945a7714bff7","5":"9d067c607c36d91894fa"}[chunkId] + "";
};